// Dezimale Eingabe ohne Gleitkomma-Rundung in Cent umwandeln.
export function zahlungsbetragInCent(value) {
  const text = String(value || '').trim();
  if (!/^\d{1,9}([,.]\d{1,2})?$/.test(text)) return null;
  const [ganz, rest = ''] = text.replace(',', '.').split('.');
  const cent = Number(ganz) * 100 + Number(rest.padEnd(2, '0'));
  return Number.isSafeInteger(cent) && cent > 0 ? String(cent) : null;
}

export function zahlungsdatumHeute() {
  const heute = new Date();
  return `${heute.getFullYear()}-${String(heute.getMonth() + 1).padStart(2, '0')}-${String(heute.getDate()).padStart(2, '0')}`;
}
